export const REPLACE_OPEN_EDITOR = "replaceOpenEditor";
export const CLOSE_OPEN_EDITOR = "closeOpenEditor";
